import {Component, OnChanges, OnInit, SimpleChanges} from "@angular/core";
import {UIService} from "@app/services/ui.service";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/api";

@Component({
  selector: 'confirmation-dialog',
  templateUrl: './confirmation.component.html'
})
export class ConfirmationComponent implements OnInit, OnChanges{

  data: string = "";

  constructor(private ui: UIService,
    private refDialog: DynamicDialogRef,
    private configDialog: DynamicDialogConfig) {
  }


  ngOnInit() {
    this.data = this.configDialog.data.text;
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.data = this.configDialog.data.text;
  }

  close(){
    this.refDialog.close();
  }

  execute(){
    this.configDialog.data.execute();
  }

}
